<mat-dialog-content>
  <form novalidate style="margin: 0">
    <lemon-dialog-header>
      {{ asiakas?.n }}
      <div style="font-size: 14px; line-height: 20px; color: rgba(0, 0, 0, 0.87); font-weight: normal; text-align: center">{{ lokalisoituKuukausiVuosi }}</div>
      <mat-checkbox #aktiivinenCheckbox style="position: absolute; left: -13px; top: 3px; font-size: 14px; color: rgba(0, 0, 0, 0.87); font-weight: normal" [formField]="lomake.aktiivinen">Aktiivinen</mat-checkbox>
    </lemon-dialog-header>

    @if (kirjanpitajaOnDevaajaObservable | async) {
      <div style="padding-bottom: 20px">
        <h3 style="margin: 0">Urit</h3>
        <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
          Kuukausiruutu: <a [href]="kuukausiruutuEncodedUriObservable | async" target="_BLANK">{{ kuukausiruutuUriObservable | async }}</a>
        </div>
      </div>
    }

    <div style="padding-left: 3em; padding-right: 3em">
      <!-- <div *ngIf="commonError" class="error-text">
      Lataushistorian lataamisen tai tositteiden lataamismerkintöjen peruuttamisen aikana tapahtui virhe. Virhe on tallennettu. Ole hyvä ja ota yhteys ylläpitoon.
    </div> -->
      <table>
        <tr>
          <td>
            <div>Kirjanpitoon käytetty aika</div>
          </td>
          <td style="text-align: center">
            <!-- {{kirjanpitoAika?.errors | json}} -->
            <mat-form-field>
              <mat-label>Aika</mat-label>
              <input type="text" #kirjanpitoaikaInput matInput [formField]="lomake.kirjanpitoAika" data-lpignore="true" />
              <mat-hint>Hinta: {{ hinta }}, teho: {{ teho }}</mat-hint>
              @if (onkoVirhe(lomake.kirjanpitoAika, 'max')) {
                <mat-error>Käytetty aika voi olla maksimissaan {{ kirjanpitoAikaEnintaan }} minuuttia</mat-error>
              }
              @if (onkoVirhe(lomake.kirjanpitoAika, 'required')) {
                <mat-error>Käytetty aika puuttuu</mat-error>
              }
              @if (onkoVirhe(lomake.kirjanpitoAika, 'min')) {
                <mat-error>Käytetyn ajan pitää olla vähintään {{ kirjanpitoAikaVahintaan }} minuutti</mat-error>
              }
              @if (onkoVirhe(lomake.kirjanpitoAika, 'number')) {
                <mat-error>Käytetty aika voi sisältää ainoastaan numeroja</mat-error>
              }
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>
            <mat-checkbox #kirjanpitoTehtyCheckbox [formField]="lomake.kirjanpitoTehty">Kirjanpito tehty</mat-checkbox>
          </td>
          <td>
            <mat-form-field>
              <mat-label>Päivämäärä</mat-label>
              <input type="text" [matDatepicker]="picker" [formField]="lomake.kirjanpitoPvm" matInput data-lpignore="true" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-error>Päivämäärä puuttuu</mat-error>
            </mat-form-field>
            <mat-datepicker #picker></mat-datepicker>
          </td>
        </tr>
        @if (naytaTilinpaatos) {
          <tr>
            <td>
              <mat-checkbox #tilinpaatosTehtyCheckbox [formField]="lomake.tilinpaatosTehty">Tilinpäätös tehty</mat-checkbox>
            </td>
            <td>
              <mat-form-field>
                <mat-label>Päivämäärä</mat-label>
                <input type="text" [matDatepicker]="picker" [formField]="lomake.tilinpaatosPvm" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-error>Päivämäärä puuttuu</mat-error>
              </mat-form-field>
              <mat-datepicker #picker></mat-datepicker>
            </td>
            <!-- <td style="text-align: center;">
          <mat-form-field>
            <input type="text" #tilinpaatosaikaInput [name]="namename" matInput formControlName="tilinpaatosAika" placeholder="Käytetty aika" data-lpignore="true" required />
            <mat-error *ngIf="tilinpaatosAika?.errors?.max">Käytetty aika voi olla maksimissaan {{tilinpaatosAika?.errors?.max?.max}} minuuttia</mat-error>
            <mat-error *ngIf="tilinpaatosAika?.errors?.required">Käytetty aika puuttuu</mat-error>
            <mat-error *ngIf="tilinpaatosAika?.errors?.min">Käytetyn ajan pitää olla vähintään {{tilinpaatosAika?.errors?.min?.min}} minuutti</mat-error>
            <mat-error *ngIf="tilinpaatosAika?.errors?.number">Käytetty aika voi sisältää ainoastaan numeroja</mat-error>
          </mat-form-field>
        </td> -->
          </tr>
        }
        @if (naytaVeroilmoitus) {
          <tr>
            <td>
              <mat-checkbox #veroilmoitusTehtyCheckbox [formField]="lomake.veroilmoitusTehty">Veroilmoitus tehty</mat-checkbox>
            </td>
            <td>
              <mat-form-field>
                <mat-label>Päivämäärä</mat-label>
                <input type="text" [matDatepicker]="picker" [formField]="lomake.veroilmoitusPvm" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-error>Päivämäärä puuttuu</mat-error>
              </mat-form-field>
              <mat-datepicker #picker></mat-datepicker>
            </td>
            <!-- <td style="text-align: center;">
        <mat-form-field>
          <input type="text" #veroilmoitusaikaInput [name]="namename" matInput formControlName="veroilmoitusAika" placeholder="Käytetty aika" data-lpignore="true" required />
          <mat-error *ngIf="veroilmoitusAika?.errors?.max">Käytetty aika voi olla maksimissaan {{veroilmoitusAika?.errors?.max?.max}} minuuttia</mat-error>
          <mat-error *ngIf="veroilmoitusAika?.errors?.required">Käytetty aika puuttuu</mat-error>
          <mat-error *ngIf="veroilmoitusAika?.errors?.min">Käytetyn ajan pitää olla vähintään {{veroilmoitusAika?.errors?.min?.min}} minuutti</mat-error>
          <mat-error *ngIf="veroilmoitusAika?.errors?.number">Käytetty aika voi sisältää ainoastaan numeroja</mat-error>
        </mat-form-field>
      </td> -->
          </tr>
        }
        @if (naytaPoytakirja) {
          <tr>
            <td>
              <mat-checkbox #poytakirjaTehtyCheckbox [formField]="lomake.poytakirjaTehty" (change)="poytakirjaTehtyMuokattu = true">Tilinpäätös rekisteröity</mat-checkbox>
            </td>
            <td>
              <mat-form-field>
                <mat-label>Päivämäärä</mat-label>
                <input #poytakirjaPvmInput type="text" [matDatepicker]="picker" [formField]="lomake.poytakirjaPvm" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-error>Päivämäärä puuttuu</mat-error>
              </mat-form-field>
              <mat-datepicker #picker></mat-datepicker>
            </td>
            <td style="text-align: center">
              <!-- {{veroilmoitusAika?.errors | json}} -->
              <!-- <mat-form-field>
        <input type="text" [name]="namename" matInput formControlName="veroilmoitusAika" placeholder="Käytetty aika" data-lpignore="true" required />
        <mat-error *ngIf="veroilmoitusAika?.errors?.max">Käytetty aika voi olla maksimissaan {{veroilmoitusAika?.errors?.max?.max}} minuuttia</mat-error>
        <mat-error *ngIf="veroilmoitusAika?.errors?.required">Käytetty aika puuttuu</mat-error>
        <mat-error *ngIf="veroilmoitusAika?.errors?.min">Käytetyn ajan pitää olla vähintään {{veroilmoitusAika?.errors?.min?.min}} minuutti</mat-error>
        <mat-error *ngIf="veroilmoitusAika?.errors?.number">Käytetty aika voi sisältää ainoastaan numeroja</mat-error>
      </mat-form-field> -->
            </td>
          </tr>
        }
      </table>

      <mat-form-field>
        <mat-label>Muistiinpanot</mat-label>
        <textarea #muistiinpanotTextarea [formField]="lomake.viesti" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"></textarea>
        <!-- cdkAutosizeMaxRows="5" -->
      </mat-form-field>
      <mat-checkbox [formField]="lomake.alvIlmoitusHoidettuJarjestelmanUlkopuolella">ALV-ilmoitus on hoidettu järjestelmän ulkopuolella</mat-checkbox>

      @if (naytaPoytakirja) {
        <div style="margin: 2em 0">
          <span style="margin-right: 4em">Tiedot osinkojen maksamisesta</span>
          <mat-radio-group [formField]="lomake.tiedotOsinkojenMaksamisesta">
            <mat-radio-button value="ei">Ei makseta</mat-radio-button>
            <mat-radio-button value="ilm">Ilmoitettu</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-secondary-button mat-dialog-close actionId="Asiakkaan kirjanpitostatus kuukaudelle: Sulje dialog">Sulje</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Asiakkaan kirjanpitostatus kuukaudelle, tallenna tiedot" [actionContext]="$any(lomake().value())">Tallenna</app-primary-button>
</mat-dialog-actions>
